export default{
  //获取投稿列表
  'App.Submission.List':{
    useJavaHost:true,
    alias:'fotooActivityBackend/querySubmissionList',
  },
  'App.Member.ReceiveCard':null,
	'App.User.Login':null,

	//创建征稿
	'App.Contribution.AddContribution':null,
	//征稿详情
	'App.Contribution.GetContributionById':{
		useJavaHost:true,
		alias:'fotoo/activity/activity',
    method:'GET',//默认协议
		params:{id:'activityId'}//参数转换
	},
	//征稿列表
	'App.Contribution.GetContributionList':null,
	//作品集
	'App.Works.GetWorksList':{
    useJavaHost:true,
    alias:'fotooActivitySubmission/queryMySubmissionList'
  },
	//创建投稿
	'App.Works.AddWorks':{
    useJavaHost:true,
		alias:'fotooActivitySubmission/add'
	},
	//获取投稿详情
	'App.Works.GetWorksById':{
    useJavaHost:true,
    alias:'fotooActivitySubmission/getSubmissionDetail/{id}',
    method:'GET',//默认协议
    //params:{id:'activityId'}//参数转换
  },
	//根据征稿创建分组
	'App.Contribution.CreateGroup':{
    useJavaHost:true,
    alias:'fotooWardingResult/add',
	},
	//加入协作
	'App.Contribution.CreateCooperation':{
    useJavaHost:true,
    alias:'fotooActivityCollaborator/add',
  },
	//获取协作列表
	'App.Contribution.GetCooperation':{
    useJavaHost:true,
    alias:'fotooActivityCollaborator/getList',
    method:'GET',//默认协议
	},
  //判断用户身份是否是协作者
  'App.identityJudge':{
    useJavaHost:true,
    alias:'fotoo/activity/identityJudge',
    method:'GET',//默认协议
    params:{cid:'activityId'}//参数转换
  },
	//查看征稿项目下分组信息
	'App.Contribution.GetGroupByContribution':{
    useJavaHost:true,
    alias:'fotooWardingResult/list',
    method:'GET',//默认协议
    params:{cid:'activityId'}//参数转换
  },
	//评选将投稿加入分组
	'App.Contribution.InsertGroup':{
    useJavaHost:true,
    alias:'fotooWardingResult/addSubmissions'
	},
	//发布分组作品
	'App.Contribution.ReleaseGroup':{
    useJavaHost:true,
    alias:'fotooWardingResult/makePublicAllSubmission',
    method:'GET',//默认协议
    params:{gid:'wardingResultId'}//参数转换
  },
	//获取用户账号信息
	'App.User.GetWorksById':null,
	//设置用户信息
	'App.User.SetUser':{
    useJavaHost:true,
    alias:'fotooUser/updateUserInfo',
  },
	//修改征稿
	'App.Contribution.SetContribution':{
    useJavaHost:true,
    method:'POST',//默认协议
    alias:'fotoo/activity/{field}/setting',
	},
	//删除征稿图片
	'App.Contribution.DelContributionImg':null,
	//登录授权
	'App.User.WxLogin':{
    useJavaHost:true,
    alias:'fotooLogin/login',
  },
	//获取七牛token
	'App.Qiniu.GetUploadToken':{
    useJavaHost:true,
    method:'GET',//默认协议
		alias:'fotoo/activity/upload/token',
	},
	//删除分组下的图片
	'App.Contribution.DeleteByGroup':{
    useJavaHost:true,
    alias:'fotooWardingResult/delSubmissions'
	},
  //活动二维码
	'App.Contribution.CreateContributionQrcode':{
    useJavaHost:true,
    alias:'/fotoo/activity/getActivityQrcode/{cid}',
    method:'GET',//默认协议
    //params:{cid:'activityId'}//参数转换
  },
	'App.User.GetUserById':{
    useJavaHost:true,
    method:'GET',//默认协议
    alias:'fotooUser/getUserInfo',
    //params:{id:'activityId'}//参数转换
	},
	//获取当前用户征稿或参与协作列表
	'App.Contribution.GetContributionByOpenid':{
    useJavaHost:true,
    method:'GET',//默认协议
    alias:'fotoo/activity/management',
  },
	//获取征稿下参与人信息
	'App.Contribution.GetContributionPeople':{
    useJavaHost:true,
    method:'GET',//默认协议
    alias:'fotoo/activity/actor/list',
    params:{id:'activityId'}//参数转换
  },
	//浏览记录//投稿浏览量
	'App.Contribution.SetBrowse':{
    useJavaHost:true,
    method:'GET',//默认协议
    alias:'fotooActivitySubmission/view/{id}',
	},
	//获取照片喜欢数量
	'App.Works.GetLikeNum':null,
	//投稿点击喜欢
	'App.Works.DoLike':{
    useJavaHost:true,
    alias:'fotooLike/add',
	},
	//图片查看记录
	'App.Works.ImgLook':null,
	//发布和未发布的照片数量
	'App.Contribution.GetReleaseByGroup':null,
	//修改分组信息
	'App.Contribution.SetGroup':{
    useJavaHost:true,
    alias:'fotooWardingResult/edit',
	},
	//获取最热征稿
	'App.Contribution.GetHotWorkList':{
    useJavaHost:true,
    alias:'fotooActivitySubmission/getActivitySubmissionList',
  },
	//获取最新征稿
	'App.Contribution.GetNewWorkList':{
    useJavaHost:true,
    alias:'fotooActivitySubmission/getActivitySubmissionList',
  },
	//查看分组下所有投稿信息
	'App.Contribution.GetGroupByWorks':{
    useJavaHost:true,
    alias:'fotooWardingResult/selectionList',
	},
	//记录小程序的formid
	'App.User.AddFormIdByOpenid':null,
	//获取精选活动
	'App.Contribution.GetEvent':null,
	//我的征稿浏览列表
	'App.Contribution.MyBrowseRecordByOpenid':{
    useJavaHost:true,
    method:'GET',//默认协议
    alias:'fotoo/activity/view/list',
	},
	//保存征稿浏览记录
	'App.Contribution.SaveBrowseRecord':{
    useJavaHost:true,
    method:'GET',//默认协议
    alias:'fotoo/activity/saveActivityViewRecord',
    params:{cid:'activityId'}//参数转换
  },
	//删除投稿
	'App.Works.DelWorks':{
    useJavaHost:true,
    alias:'fotooActivitySubmission/delete',
	},
  //隐藏投稿
  'App.Contribution.SetEventHide':{
    useJavaHost:true,
    alias:'fotooActivitySubmission/editAuditStatus',
  },
  //人工审核投稿&投稿图片
	'App.Works.SetWorkExamine':{
    useJavaHost:true,
    alias:'fotooActivitySubmission/editAuditStatus',
  },
	//所有投稿列表
	'App.Works.GetAllWorkList':{
    useJavaHost:true,
    alias:'fotooActivitySubmission/list',
  },
	//获取运营列表
	'App.User.GetOperateList':null,
	//运营人员列表
	'App.User.GetOperate':{
    useJavaHost:true,
    alias:'fotooUser/isManager',
    method:'GET',//默认协议
  },
	//PC登录
	'App.User.PcLogin':null,
	//获取投稿上下
	'App.Contribution.GetWorkByOrder':null,
	//点赞列表
	'App.Contribution.GetLikeListById':{
    useJavaHost:true,
    alias:'fotooActivitySubmission/getActivitySubmissionList',
  },
	//生成投稿图片二维码
	'App.Works.CreateWorkQrcode':null,
	//图片浏览记录
	'App.Works.ImgLook':null,
	//搜索
	'App.Works.SearchWorks':{
    useJavaHost:true,
    alias:'fotooActivitySubmission/getSearchSubmissionList',
  },
	//评论
	'App.Works.Comment':{
    useJavaHost:true,
    alias:'fotooComment/add',
  },
	//评论列表
	'App.Works.GetCommentList':{
    useJavaHost:true,
    alias:'fotooComment/getCommentList',
  },
	//点赞评论
	'App.Works.LikeComment':{
    useJavaHost:true,
    alias:'fotooLike/add',
  },
	//'删除评论'
	'App.Works.DelComment':{
    useJavaHost:true,
    alias:'fotooComment/delete/{id}',
    method:'DELETE',//默认协议
  },
	//移除协作人
	'App.Contribution.DelCooperation':{
    useJavaHost:true,
    alias:'fotooActivityCollaborator/delete/{id}',
    method:'DELETE',//默认协议
  },
	//修改协作人
	'App.Contribution.SetCooperation':{
    useJavaHost:true,
    alias:'fotooActivityCollaborator/editRemark',
  },
	//获取咨询
	'App.Works.GetConsults':null,
	//用户针对征稿进行问答
	'App.Works.SetConsults':null,
	//获取视频存储token
	'App.Qiniu.GetVideoUploadToken':{
    useJavaHost:true,
    method:'GET',//默认协议
    alias:'fotoo/activity/upload/token',
  },
	'App.Activity.Statistics':{
    useJavaHost:true,
    method:'GET',//默认协议
    alias:'fotoo/activity/statistics/{activityId}',
	},
  'App.Submission.Statistics':{
    useJavaHost:true,
    method:'GET',//默认协议
	  alias:'fotooActivitySubmission/getSubmissionStatistics/{submissionId}'
  },
  'App.Submission.likeStatus':{
    useJavaHost:true,
    method:'GET',//默认协议
	  alias:'fotooLike/submissionLikeStatus/{submissionId}'
  },
  'App.System.Qrcode':{
    useJavaHost:true,
    method:'GET',//默认协议
    alias:'fotoo/wechatapplet/getActivityQrcode',
  },
  'App.Reply.Add':{
    useJavaHost:true,
    alias:'fotooReply/add',
  },
  'App.Reply.List':{
    useJavaHost:true,
    alias:'fotooReply/getReplyList',
  },
  'App.Reply.Delete':{
    useJavaHost:true,
    alias:'fotooReply/delete/{id}',
    method:'DELETE',//默认协议
  },
  'App.Activity.Award':{
    useJavaHost:true,
    alias:'fotooActivityAward/getActivityAwardInfo/{activityId}',
    method:'GET',//默认协议
  },
  'App.Submission.Export':{
    useJavaHost:true,
    alias:'fotooActivityBackend/exportSubmissionExcel',
    method:'GET',//默认协议
  },
  'App.Download.Add':{
    useJavaHost:true,
    alias:'download/userDownload'
  },
  'App.Download.List':{
    useJavaHost:true,
    alias:'download/queryList'
  },
  'App.Activity.generateUrlSchema':{
    useJavaHost:true,
    alias:'/activity/generateUrlSchema',
    method:'POST',
  }
}


// WEBPACK FOOTER //
// ./src/util/api.js